export const selectLoginError = (state) => state.login?.error
export const selectLoginStep = (state) => state.login?.loginStep
export const selectLoginLoader = (state) => state.login?.loginLoader
export const selectLoginSubmitLoader = (state) => state.login?.loginSubmitLoader
export const selectEulaHTML = (state) => state.login?.eulaHTML
export const selectTimeTillUnblock = (state) => state.login?.timeTillUnblock
export const selectTFAParingUrl = (state) => state.login?.tfaParingUrl
export const selectSSOUrl = (state) => state.login?.ssoUrl
